module.exports = __webpack_public_path__ + "img/circulo.0cdeba65.png";